import { withStyles } from "@material-ui/core"
import Typography from "@mui/material/Typography"
import React, { useEffect, useState } from "react"
import { grayColor } from "../../../style/style"
import WidgetCommon from "../Common/widgetCommon"

const styles = () => ({
  widget: {
    color: grayColor[2],
    textAlign: "center",
  },
})

const TotalInsights = (props) => {
  const {
    isLoading,
    insights,
    classes,
    allowEdits,
    handleWidgetChange,
    widgetId,
    gridStep,
    position,
    size,
    handleRemove,
  } = props
  const [totalInsights, setTotalInsights] = useState(null)

  useEffect(() => {
    if (insights) {
      setTotalInsights(insights.length)
    }
  }, [insights])

  return (
    <WidgetCommon
      gridStep={gridStep}
      widgetId={widgetId}
      title="Total Insights"
      isLoading={isLoading}
      handleRemove={handleRemove}
      hasNoData={!totalInsights}
      size={size}
      position={position}
      allowResize={true}
      allowEdits={allowEdits}
      handleWidgetChange={handleWidgetChange}
    >
      <br></br>
      <Typography variant="h2" className={classes.widget}>
        {totalInsights}
      </Typography>
    </WidgetCommon>
  )
}

export default withStyles(styles)(TotalInsights)
